<template>
  <div class="home">
     <div class="homes">
       <div class="con">
            <div class="left">
               <div class="geren">
                 <span style="margin-top: -5px;">个人中心</span>
               </div>
               <div class="navs" @click="type=1" :class="[type==1?'select':'']">
                 <span>基本信息</span>
                <img src="../../assets/xiangyou01.png" alt="" v-if="type!=1">
                <img src="../../assets/xiangyou02.png" alt="" v-else>
               </div>
<!--               <div class="navs" :class="[type==2?'select':'']">
                 <span>我的志愿单</span>
                 <img src="../../assets/xiangyou01.png" alt="" v-if="type!=2">
                 <img src="../../assets/xiangyou02.png" alt="" v-else>
               </div> -->
               <div class="navs" @click="type=3" :class="[type==3?'select':'']">
                 <span>VIP会员</span>
                 <img src="../../assets/xiangyou01.png" alt="" v-if="type!=3">
                 <img src="../../assets/xiangyou02.png" alt="" v-else>
               </div>
               <div class="navs" @click="type=7" v-if="userinfo && (userinfo.role==3||(userinfo.role==2&&!(userinfo.is_sheng==1&&userinfo.isFen!=1))||userinfo.role==1)" :class="[type==7?'select':'']">
                 <span>下级会员</span>
                 <img src="../../assets/xiangyou01.png" alt="" v-if="type!=7">
                 <img src="../../assets/xiangyou02.png" alt="" v-else>
               </div>
               <div class="navs" @click="type=4" :class="[type==4?'select':'']">
                 <span>我的测评</span>
                 <img src="../../assets/xiangyou01.png" alt="" v-if="type!=4">
                 <img src="../../assets/xiangyou02.png" alt="" v-else>
               </div>
               <div class="navs" @click="type=6" :class="[type==6?'select':'']">
                 <span>我的钱包</span>
                 <img src="../../assets/xiangyou01.png" alt="" v-if="type!=6">
                 <img src="../../assets/xiangyou02.png" alt="" v-else>
               </div>
               <div class="navs" @click="type=5" :class="[type==5?'select':'']">
                 <span>修改密码</span>
                 <img src="../../assets/xiangyou01.png" alt="" v-if="type!=5">
                 <img src="../../assets/xiangyou02.png" alt="" v-else>
               </div>
            </div>
            <div class="right">
               <div class="rights">
                 <div class="righttitle">
                   <div class="rightclear"></div>
                   {{
                     type==1?"基本信息":type==2?"我的志愿单":type==3?"VIP会员":type==4?"我的测评":type==5?"修改密码":type==6?"我的钱包":type==7?"下级会员":"个人中心"
                   }}

                   <el-button type="success" size="small" style="margin-left: auto;" @click="$refs.payData.show()">购卡</el-button>
                 </div>

                 <div class="rightcon">
                    <infoVue v-if="type==1" />
                    <vipVue v-if="type==3" />
                    <cepingVue v-if="type==4" :activeName="activeName" />
                    <resetPass v-if="type==5" />
                    <moneyVue v-if="type==6" />
                    <xiajiVue v-if="type==7" />
                 </div>
               </div>
            </div>
       </div>
     </div>
     <!--购卡-->
     <payCard ref="payData" />

  </div>
</template>

<script>
  import {mapGetters} from "vuex"
  import infoVue from "./components/info.vue"
  import resetPass from "./components/resetPass.vue"
  import vipVue from "./components/vip.vue"
    import payCard from "./components/payCard.vue"
    import moneyVue from "./components/money.vue"
    import xiajiVue from "./components/xiaji.vue"
    import cepingVue from "./components/ceping.vue"
  export default {
    components:{
      infoVue,
      resetPass,
      vipVue,
      payCard,
      moneyVue,
      xiajiVue,
      cepingVue
    },
    computed:{
      ...mapGetters(['isLogin',"userinfo"]),
    },
    data(){
      return{
       type:1,//1基本信息 2我的志愿单  3会员中心  4我的测评 5修改密码 6我的钱包 7下级会员
       activeName:'1'
      }
    },
    watch:{

    },
    mounted(){
      if(this.$route.query.type){
        this.type = this.$route.query.type
      }
      if(this.$route.query.activeName){
        this.activeName = this.$route.query.activeName
      }
      this.$store.dispatch("set_nav",null);
      this.$store.dispatch("getUserInfo");
    },
    methods:{

    },
  }
</script>

<style lang="scss" scoped>
  .rightcon{
    width: 100%;
    max-height: 600px;
    overflow: scroll;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .righttitle{
    width: 100%;
    padding-top: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #E8EAF0;
    display: flex;
    align-items: center;
    color:#515151;
    font-size: 20px;
    font-weight: bold;
    .rightclear{
      width: 8px;
      height: 20px;
      background: #2aa38b;
      border-radius: 4px;
      margin-right: 10px;
    }
  }
  .rights{
    width: 958px;
    margin: 0 auto;
  }
  .select{
    background: #c9f6ed;
    border-radius: 10px;
    span{
      color:#2aa38b!important;
    }
  }
  .navs:hover{
    background: #c9f6ed;
    border-radius: 10px;
    span{
      color:#2aa38b!important;
    }
  }
  .navs{
    width: 200px;
    height: 48px;
    display: flex;
    align-items: center;
    margin-top: 30px;
    cursor: pointer;
    span{
      color: #515151;
      font-size: 22px;
      margin-left: 21px;
    }
    img{
      width: 8px;
      height: 14px;
      margin-left: auto;
      margin-right: 26px;
    }
  }
  .geren{
    width: 200px;
    height: 65px;
    background: url("../../assets/gerensan.png") no-repeat;
    background-size: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    font-weight: 500;
    color: #fff;
    margin-top: 16px;
  }
.home{
  width: 100%;
  .homes{
    width: 1250px;
    margin: 0 auto;
    .con{
      width: 100%;
      height: 730px;
      margin-top: 20px;
      margin-bottom: 20px;
      background: #fff;
      border-radius: 10px;
      display: flex;
      .left{
        width: 230px;
        height: 100%;
        border-right: 1px solid #E8EAF0;
        display: flex;
        align-items: center;
        flex-direction: column;
      }
      .right{
        width: 1020px;
        height: 100%;

      }
    }
  }
}
</style>
<style>
  body,html{
    background: #F3F4F7!important;
  }
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue